import { NgForm } from '@angular/forms';
import { CeiSnackBarService } from '@cei-ufg/ngx-arquitetura-cei-frontend';

export function stopIfAdminFormInvalid(form: NgForm): boolean {
  if (form.invalid) {
    form.control.markAllAsTouched();
    return true;
  }

  return false;
}

export function notifyAdminFormSuccess(snackBar: CeiSnackBarService, message: string): void {
  snackBar.success(message);
}

export function notifyAdminFormError(
  snackBar: CeiSnackBarService,
  fallbackMessage: string,
  error?: unknown,
): void {
  snackBar.error(extrairMensagemErroApi(error) ?? fallbackMessage);
}

/** Prefere detail/body da API; evita HttpErrorResponse.message genérico. */
function extrairMensagemErroApi(error: unknown): string | null {
  if (error == null) {
    return null;
  }
  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }
  if (typeof error !== 'object') {
    return null;
  }

  const http = error as { error?: unknown; detail?: unknown };
  const corpo = http.error;

  if (typeof corpo === 'string' && corpo.trim()) {
    return corpo.trim();
  }
  if (corpo && typeof corpo === 'object') {
    const detail = (corpo as { detail?: unknown }).detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail.trim();
    }
  }
  if (typeof http.detail === 'string' && http.detail.trim()) {
    return http.detail.trim();
  }
  return null;
}
